<template>
  <div class="personsetup">
    <div class="header">
      <div style="display:flex;align-items: center;">
        <img src="@/assets/house/breadicon.png" style="margin-right:10px" alt />
        <el-breadcrumb separator="/">
          <!-- <el-breadcrumb-item>工作桌面</el-breadcrumb-item> -->
          <el-breadcrumb-item>系统设置</el-breadcrumb-item>
          <el-breadcrumb-item>常用信息</el-breadcrumb-item>
          <!-- <el-breadcrumb-item>活动详情</el-breadcrumb-item> -->
        </el-breadcrumb>
      </div>
      <div class="refresh">
        <img width="16px" height="16px" src="@/assets/house/refresh.png" alt />
        <p>刷新</p>
      </div>
    </div>

    <div class="main">
      <h4>常用信息</h4>
      <div class="upbg">
        <div style="width:1100px; margin:0 auto;">
         
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {

  watch: {},
  data() {
    return {
      
    };
  },
  methods: {
    
  },
  created() {
  },
  mounted() {
    // this.$nextTick(() => {
    //   window.uploader = this.$refs.uploader.upload;
    // })
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
@import "./personsetup.scss";

h4 {
  font-size: 18px;
}

.uploader-example {
  width: 880px;
  padding: 15px;
  margin: 40px auto 0;
  font-size: 12px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.4);
}
.uploader-example .uploader-btn {
  margin-right: 4px;
}
.uploader-example .uploader-list {
  max-height: 440px;
  overflow: auto;
  overflow-x: hidden;
  overflow-y: auto;
}
</style>
